import { fontSizeProp } from 'helpers/style';
import PropTypes from 'prop-types';
import { FONT_SIZES } from '../../src/theme/font';
import styled from '@emotion/styled';

export const caps = (props) => (props.caps ? { textTransform: 'uppercase' } : null);
export const color = (props) => (props.color ? { color: props.theme.color[props.color] } : null);
export const regular = (props) => (props.regular ? { fontWeight: 400 } : null);
export const bold = (props) => (props.bold ? { fontWeight: 700 } : null);
export const noWrap = (props) => (props.noWrap ? { whiteSpace: 'nowrap' } : null);

const Text = styled.div`
    font-family: ${({ theme }) => theme.font.regular};

    ${color};
    ${fontSizeProp};
    ${caps};
    ${bold};
    ${regular};
    display: inline-block;
`;

Text.displayName = 'Text';

Text.propTypes = {
    caps: PropTypes.bool,
    regular: PropTypes.bool,
    bold: PropTypes.bool,
};

Text.defaultProps = {
    fontSize: FONT_SIZES.mediumLarge,
};

const TextExtraSmall = styled(Text)`
    line-height: 12px;
    font-size: ${(p) => p.theme.fontSize.extraSmall};
`;

const TextSmall = styled(Text)`
    line-height: 16px;
    font-size: ${(p) => p.theme.fontSize.small};
    @media (max-width: ${(p) => p.theme.breakpoint.desktop}px) {
        line-height: 12px;
        font-size: ${(p) => p.theme.fontSize.extraSmall};
    }
`;

const TextMediumSmall = styled(Text)`
    line-height: 16px;
    font-size: ${(p) => p.theme.fontSize.mediumSmall};
    @media (max-width: ${(p) => p.theme.breakpoint.desktop}px) {
        line-height: 16px;
        font-size: ${(p) => p.theme.fontSize.small};
    }
`;

const TextMedium = styled(Text)`
    line-height: 18px;
    font-size: ${(p) => p.theme.fontSize.medium};
    @media (max-width: ${(p) => p.theme.breakpoint.desktop}px) {
        line-height: 16px;
        font-size: ${(p) => p.theme.fontSize.mediumSmall};
    }
`;

const TextMediumRapid = styled(Text)`
    line-height: 18px;
    font-size: ${(p) => p.theme.fontSize.medium};
    @media (max-width: ${(p) => p.theme.breakpoint.desktopLarge}px) {
        line-height: 16px;
        font-size: ${(p) => p.theme.fontSize.small};
    }
`;

const TextMediumLarge = styled(Text)`
    line-height: 22px;
    font-size: ${(p) => p.theme.fontSize.mediumLarge};
    @media (max-width: ${(p) => p.theme.breakpoint.desktop}px) {
        line-height: 18px;
        font-size: ${(p) => p.theme.fontSize.medium};
    }
`;

const TextMediumLargeRapid = styled(Text)`
    line-height: 22px;
    font-size: ${(p) => p.theme.fontSize.mediumLarge};
    @media (max-width: ${(p) => p.theme.breakpoint.desktopLarge}px) {
        line-height: 20px;
        font-size: ${(p) => p.theme.fontSize.medium};
    }
`;

const TextMediumDesktopLarge = styled(Text)`
    line-height: 22px;
    font-size: ${(p) => p.theme.fontSize.mediumLarge};
    @media (max-width: ${(p) => p.theme.breakpoint.desktopLarge}px) {
        line-height: 18px;
        font-size: ${(p) => p.theme.fontSize.medium};
    }
`;

const TextLarge = styled(Text)`
    line-height: 26px;
    font-size: ${(p) => p.theme.fontSize.large};
    @media (max-width: ${(p) => p.theme.breakpoint.desktop}px) {
        line-height: 22px;
        font-size: ${(p) => p.theme.fontSize.mediumLarge};
    }
`;

const TextExtraLarge = styled(Text)`
    line-height: 30px;
    font-size: ${(p) => p.theme.fontSize.extraLarge};
    @media (max-width: ${(p) => p.theme.breakpoint.desktop}px) {
        line-height: 26px;
        font-size: ${(p) => p.theme.fontSize.large};
    }
`;

const TextExtraLargeRapid = styled(Text)`
    line-height: 30px;
    font-size: ${(p) => p.theme.fontSize.extraLarge};
    @media (max-width: ${(p) => p.theme.breakpoint.desktopLarge}px) {
        line-height: 26px;
        font-size: ${(p) => p.theme.fontSize.large};
    }
`;

const A = styled.a`
    color: ${(p) => p.theme.color.blue};
    text-decoration: none;

    &:hover {
        color: #1e70bf;
        text-decoration: none;
    }
`;

const LinkUnderlined = styled.a`
    color: inherit;
    text-decoration: underline;

    &:hover {
        color: #1e70bf;
        text-decoration: none;
    }
`;

export {
    A,
    LinkUnderlined,
    Text,
    TextExtraSmall,
    TextSmall,
    TextMediumSmall,
    TextMedium,
    TextMediumRapid,
    TextMediumLarge,
    TextMediumDesktopLarge,
    TextMediumLargeRapid,
    TextLarge,
    TextExtraLarge,
    TextExtraLargeRapid,
};
